import BotUserCard from './BotUserCard'

export default BotUserCard


// WEBPACK FOOTER //
// ./src/components/BotUserCard/index.js